import React, {useEffect,useState,} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './css/user.module.css';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DataTable from "react-data-table-component";
import $ from 'jquery';

function LineRegister(){

const { aid ,aidtype} = useParams();

const [vendorCandidates, setStaff] = useState([]); // vendor
const [recruiterCandidates, setStaff2] = useState([]); // recruiter

const [fileUrl, setFileUrl] = useState(null);
const [fileType, setFileType] = useState(null);
const [total,setTotal]= useState(0);
const [results, setResults] = useState(null);
const [showResultsModal, setShowResultsModal] = useState(false);

const [loadings, setTableLoading] = useState(true);
const [newloading,setNewLoading] = useState(false);

const [groupByLocation, setGroupByLocation] = useState({ ALL: "NONE" });
const [selectedLocation, setSelectedLocation] = useState(null);
const [groupByProfile, setGroupByProfile] = useState({ ALL: "NONE" });
const [selectedProfile, setSelectedProfile] = useState(null);
const [groupbyExp, setGroupbyExp] = useState({ ALL: "NONE" });
const [selectedExp, setSelectedExp] = useState(null);
const [selectedRows, setSelectedRows] = useState([]);
const [activeTab, setActiveTab] = useState("recruiter");
const [showRecruiter, setShowRecruiter] = useState(false);
const [showVendor, setShowVendor] = useState(false);
const [selectedRecruiter, selectRecruiter] = useState(null);
const [isSubmittingRequest, setIsSubmittingRequest] = useState(false);
const [filteredStaff, setFilteredStaff] = useState([]);
const [ivrdata,setIvrData] = useState("");
const [ivr,setIvr] = useState("");
const [candidates,setCandidates]= useState([]);
 const [openReqs, setOpenReqs] = useState({}); // ✅ track open/close requirement IDs


const [recruiter, setRecruiter] = useState([]);
const [groupedRecruiterData, setGroupedRecruiterData] = useState([]);
const [groupedData, setGroupedData] = useState([]);


const [metaData, setMetaData] = useState({
  appname: '',
  edit: false,
  del: false,
  add: false,
  view: false,
  typess:'',
  icon:'',
  checkbox:0,
  defaultShow:10
});


const fetchData = async () => {
  const response = await axios.get(apiurl+'registeration.php?subdomain=react&aid='+aid+"&aidtype="+aidtype); // Replace with your API endpoint

   setStaff(response.data.vendor);
   setStaff2(response.data.staffs);
   setGroupByLocation(response.data.glocation);
   setGroupByProfile(response.data.gprofile);
   setGroupbyExp(response.data.expe);
   setRecruiter(response.data.recruiter);
  
      const grouped = Object.values(response.data.requirements || {});
      setGroupedData(grouped);
      setGroupedRecruiterData(grouped);
  
    setMetaData({
  appname: response.data.appname,
  edit: response.data.edit,
  del: response.data.del,
  add: response.data.add,
  view: response.data.view,
  typess:response.data.typess,
  icon:response.data.icon,
  defaultShow:response.data.defaultShow,
  checkbox:response.data.checkbox
   });

 setTotal(response.data.total);
 setTableLoading(false);

};

const locationOptions = [
  { label: "ALL", value: "NONE" },
  ...Object.keys(groupByLocation)
    .map(locName => ({
      value: locName,
      label: locName
    }))
];

const profileOptions =[{ label: "ALL", value: "NONE" }, ...Object.keys(groupByProfile).map((locName) => ({
  value: locName,
  label: locName
}))];


const placementType = [
  { value: 'contract_staffing', label: 'Contract Staffing' },
  { value: 'permanent_sourcing', label: 'Permanent Sourcing' },
  { value: 'apprenticeship', label: 'Apprenticeship' },
  { value: 'gig_staffing', label: 'GIG Staffing' },
  { value: 'measurement_contract', label: 'Measurement Contract' }
];


const handleLocationChange = (selectedOption) => {
  setSelectedLocation(selectedOption);
  filterBtn({ location: selectedOption.value });
};

const handleProfileChange = (selectedOption) => {
  setSelectedProfile(selectedOption);
  filterBtn({ profile: selectedOption.value });
};
const handleExpChange = (selectedOption) => {
  setSelectedExp(selectedOption); 
  filterBtn({ experience: selectedOption.value });
};

  const experienceOptions = [
  { value:'NONE', label:'ALL'},
  { value: 'Fresher', label: 'Fresher' },
  { value: '<1 year', label: '<1 year' },
  { value: '1-2 years', label: '1–2 years' },
  { value: '2-3 years', label: '2–3 years' },
  { value: '3-4 years', label: '3–4 years' },
  { value: '4-5 years', label: '4–5 years' },
  { value: '5-7 years', label: '5–7 years' },
  { value: '7-10 years', label: '7–10 years' },
  { value: '10+ years', label: '10+ years' },
  { value: '15+ years', label: '15+ years' }
];

const filterBtn = async ({ location, profile, experience }) => {
  const data = {
    location: location ?? selectedLocation?.value,
    profiles: profile ?? selectedProfile?.value,
    expp: experience ?? selectedExp?.value,
    aid: aid,
    aidtype:aidtype,
    subdomain: "react",
  };

  $("#showLoader").removeClass("d-none").addClass("d-flex");

  try {
    const response = await axios.get(apiurl + "registeration.php", {
      params: data,
    });
   
    setStaff(response.data.vendor);
    setStaff2(response.data.staffs);
    setTotal(response.data.total);
    
  } catch (error) {
    console.error("Filter error:", error);
  } finally {
    $("#showLoader").removeClass("d-flex").addClass("d-none");
  }
};


useEffect(() => {
  document.title = "Candidate | MERAQUI";
    fetchData();
  $('#modalclose').on('click', function () {
    $("#hidden").val("");
    $("#reset").click();
    setFileType(null);
    setFileUrl(null);
    checks('1');


  });

}, []);

useEffect(() => {
  if (aidtype === '2') {
    setShowVendor(true);
  }

  if (showVendor && showRecruiter) {
    setFilteredStaff([...vendorCandidates, ...recruiterCandidates]);
  } else if (showVendor) {
    setFilteredStaff(vendorCandidates);
  } else if (showRecruiter) {
    setFilteredStaff(recruiterCandidates);
  } else {
    setFilteredStaff([...vendorCandidates, ...recruiterCandidates]);
  }

}, [showVendor, showRecruiter, vendorCandidates, recruiterCandidates]);

  useEffect(() => {
  if (activeTab === "vendor" && aidtype===3) {
    setSelectedRows([]);
  }
}, [activeTab]);

// form submit in category
const FormSubmit = async (e) =>{
          e.preventDefault();
          // try and catch method
            try {
              const formData = new FormData($("#mainForm")[0]);
              if($("#hidden").val()==""){
                if($("#resume").val().length==0){
                   Swal.fire({
                       position:'top-center',
                       icon:'question',
                       title:"Please select the resume"
                   });
                   return false;
                }
              }

              
             $("#showLoader").removeClass('d-none').addClass('d-flex');
               const response = await axios.post(apiurl + "registeration.php", formData);
              if (response.data.status==true) {
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                                      Swal.fire({
                                        position: "top-center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    }).then(()=>{
                                      $(".btn-close").click();
                                      fetchData();
                                    });
              }
              else{
               $("#showLoader").removeClass('d-flex').addClass('d-none');
                Swal.fire({
                  position: "top-center",
                  icon: "error",
                  title: response.data.message,
                  showConfirmButton: false,
                  timer: 2000
                  });
              }
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
            finally {
                $("#loader").css("display", "none");
            }
};

// delete the data from the category
 const DeleteData = async (id) =>{
   if(!id){return false;}
     const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this data!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
      });

   if(result.isConfirmed){
    try {
       const response = await axios.get(apiurl+"registeration.php?del="+id);
       if (response.data.status ==true) {
                                    Swal.fire({
                                        position: "top-center",
                                        icon: "success",
                                        title: response.data.message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    }).then(()=>{
                                      fetchData();
                                    });
  
       }
       else{
      console.log(response.data.message);
       }
    }
    catch(error){
      console.error('Error deleting category:', error);
    }


  };
  
};

function checks(dd){
  if(dd=='1'){
       $("#mainForm input, #mainForm select").attr("required",true);
        $("#mainForm input[type=file]").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",false);
         $("#mainForm .btn-primary, #resumelabel").show();
  }
  else{
        $("#mainForm input, #mainForm select").attr("required",false);
         $("#mainForm input, #mainForm select").prop("readonly",true);
         $("#mainForm .btn-primary, #resumelabel").hide();
  }
}

//edit the form
const EditData = async (edit,sss) =>{
   if(edit){
  $("#showLoader").removeClass('d-none').addClass('d-flex');
    try{
    const response = await axios.get(apiurl+'registeration.php?edit='+edit);
    if(response.data.status==true){
      $("#name").val(response.data.data[0].name);
      $("#email").val(response.data.data[0].email);
      $("#profile").val(response.data.data[0].profile);
      $("#mobile").val(response.data.data[0].phone);
      $("#age").val(response.data.data[0].age);
      $("#exp").val(response.data.data[0].exp);
      $("#age").val(response.data.data[0].age);
      $("#qual").val(response.data.data[0].qual.trim());
      $("#pincode").val(response.data.data[0].pincode);
      $("#city").val(response.data.data[0].city);
      $("#state").val(response.data.data[0].state);
      $("#hidden").val(response.data.data[0].hidden);
      setFileType(response.data.data[0].fileType);
      setFileUrl(response.data.data[0].fileUrl);
       $('#addStaffbtn').click();
        checks(sss);
     $("#showLoader").removeClass('d-flex').addClass('d-none');
    }else{
      // modal can't show
      alert("data not found");
    }
    
  }
  catch(error){
    console.error('Error deleting category:', error);
  }

}
  
};
 
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setFileUrl(url);
    setFileType(file.type);
  };

const BulkUploadResultsModal = ({ show, onClose, results = {} }) => {
    const safeResults = results || {};
    const { alreadyExist = [], duplicate = [], unique = [] } = safeResults;

    useEffect(() => {
      if (show) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return () => (document.body.style.overflow = "");
    }, [show]);

    if (!show) return null;

    const SummaryRow = ({ label, count, colorClass }) => (
      <div className="me-3 d-flex align-items-center">
        <span
          className={`badge ${colorClass} rounded-pill me-2`}
          style={{ minWidth: 28 }}
        >
          {count}
        </span>
        <small className="text-muted">{label}</small>
      </div>
    );

    const Table = ({ title, items, emptyMessage }) => (
      <div className="mb-3">
        <h6 className="mb-2">
          {title} <small className="text-muted">({items.length})</small>
        </h6>
        <div className="table-responsive" style={{ maxHeight: "360px", overflowY: "auto" }}>
          <table className="table table-hover table-sm align-middle">
            <thead className="table-light sticky-top">
              <tr>
                <th style={{ width: "6%" }}>#</th>
                <th style={{ width: "34%" }}>Name</th>
                <th style={{ width: "24%" }}>Mobile</th>
                <th style={{ width: "30%" }}>Email</th>
                <th style={{ width: "6%" }} className="text-end">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted py-4">
                    {emptyMessage}
                  </td>
                </tr>
              ) : (
                items.map((it, idx) => (
                  <tr key={`${it.mobile}-${idx}`}>
                    <td>{idx + 1}</td>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 220,
                      }}
                      title={it.name}
                    >
                      {it.name || "-"}
                    </td>
                    <td>{it.mobile || "-"}</td>
                    <td
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 260,
                      }}
                      title={it.email}
                    >
                      {it.email || "-"}
                    </td>
                    <td className="text-end">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => navigator.clipboard?.writeText(it.mobile || "")}
                        title="Copy mobile"
                      >
                        Copy
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );

    return (
      <>
      <div className="bulk-results-modal">
        <div className="modal-backdrop fade show"></div>
        <div className="modal d-block fade show" tabIndex={-1} role="dialog" aria-modal="true">
          <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div className="modal-content shadow-lg rounded-3">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title">Bulk Upload — Results</h5>
                  <div className="d-flex mt-1">
                    <SummaryRow label="Added (unique)" count={unique.length} colorclassName="bg-success text-white" />
                    <SummaryRow label="Duplicates in CSV" count={duplicate.length} colorclassName="bg-warning text-dark" />
                    <SummaryRow label="Already in Database" count={alreadyExist.length} colorclassName="bg-secondary text-white" />
                  </div>
                </div>
                <div>
                  <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                </div>
              </div>

              <div className="modal-body">
                <ul className="nav nav-tabs mb-3" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" data-bs-target="#added" id="tab-added" data-bs-toggle="tab" type="button" role="tab" aria-controls="added" aria-selected="true">Added</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="tab-duplicate" data-bs-target="#duplicate" data-bs-toggle="tab" type="button" role="tab" aria-controls="duplicate" aria-selected="false">Duplicates</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link" id="tab-already" data-bs-target="#already" data-bs-toggle="tab" type="button" role="tab" aria-controls="already" aria-selected="false">Already in DB</button>
                  </li>
                </ul>

                <div className="tab-content">
                  <div className="tab-pane fade show active" id="added" role="tabpanel" aria-labelledby="tab-added">
                    <Table title="Unique / Inserted into database" items={unique} emptyMessage="No new records were inserted." />
                  </div>
                  <div className="tab-pane fade" id="duplicate" role="tabpanel" aria-labelledby="tab-duplicate">
                    <Table title="Duplicates found in CSV (skipped)" items={duplicate} emptyMessage="No duplicate mobiles found in CSV." />
                  </div>
                  <div className="tab-pane fade" id="already" role="tabpanel" aria-labelledby="tab-already">
                    <Table title="Already present in database (skipped)" items={alreadyExist} emptyMessage="No existing mobiles found in DB." />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <div className="me-auto text-muted small">
                  Total rows shown: {unique.length + duplicate.length + alreadyExist.length}
                </div>
                <button className="btn btn-outline-secondary" onClick={() => {
                  const allRows = [
                    ["type", "name", "mobile", "email"],
                    ...unique.map((i) => ["added", i.name, i.mobile, i.email]),
                    ...duplicate.map((i) => ["duplicate", i.name, i.mobile, i.email]),
                    ...alreadyExist.map((i) => ["already", i.name, i.mobile, i.email]),
                  ];
                  const csv = allRows.map(r => r.map(c => '"' + String(c || "").replace(/\"/g,'""') + '"').join(',')).join('\n');
                  const blob = new Blob([csv], { type: 'text/csv' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'bulk-upload-results.csv';
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  URL.revokeObjectURL(url);
                }}>Download CSV</button>
                <button className="btn btn-primary" onClick={onClose}>Close</button>
              </div>
            </div>
          </div>
        </div>

        {newloading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        <style jsx>{`
          .modal-backdrop { z-index: 1040; }
          .modal { z-index: 1050; }
          .table thead.sticky-top { top: 0; }
          .loader-overlay {
            position: fixed;
            top:0; left:0; right:0; bottom:0;
            background: rgba(255,255,255,0.7);
            display:flex;
            justify-content:center;
            align-items:center;
            z-index:2000;
          }
        `}</style>
      </div>
    </>
  );

  };

// form submit in category
const BulkFormSubmit = async (e) =>{
          e.preventDefault();
          // try and catch method
            try {
              const formData = new FormData($("#bulkform")[0]);
              if($("#bulk").val().length==0){
                Swal.fire({
                       position:'top-center',
                       icon:'question',
                       title:"Please select the bulk candidate file"
                   });
                   return false;
              }
              
              $("#showLoader").removeClass("d-none").addClass("d-flex");
              const response = await axios.post(apiurl + "registeration.php", formData);
              if (response.data.status === true) {

  setResults({
  alreadyExist: response.data.already || [],
  duplicate: response.data.duplicate || [],
  unique: response.data.unique || []
});
      setShowResultsModal(true);

      $("#modalclose2").click();
      $("#bulkform input").val("");
      fetchData();

               }
              else{
                Swal.fire({
                  position: "top-center",
                  icon: "error",
                  title: response.data.messages,
                  showConfirmButton: false,
                  timer: 2000
                  });
              }
               $("#showLoader").removeClass("d-flex").addClass("d-none");
            } catch (error) {
              console.log(error.response?.data?.message); // Handle errors with informative messages
            }
};

const currentRows = aidtype === '3' || aidtype === '30'? (activeTab === 'recruiter' ? recruiterCandidates : vendorCandidates)  : (showRecruiter && !showVendor ? recruiterCandidates : showVendor && !showRecruiter ? vendorCandidates : filteredStaff);
const primaryCount=currentRows.length; 
const secondaryCount=vendorCandidates.length;
const warningCount=recruiterCandidates.length; 

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(currentRows.map((row) => row.id)); // select all ids
    } else {
      setSelectedRows([]); // clear all
    }
  };

  // Handle individual checkbox
  const handleRowSelect = (id, checked) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, id]);
    } else {
      setSelectedRows((prev) => prev.filter((rowId) => rowId !== id));
    }
  };

  let columns = [];
  const baseColumns = [
 
  { name: "Name", selector: row => row.name, sortable: true, wrap: true },
  { name: "Mobile Number", selector: row => row.mobile, sortable: true, wrap: true },
  { name: "Profile", selector: row => row.profile, sortable: true, wrap: true },
  { name: "Email", selector: row => row.email, sortable: true, wrap: true },
  { name: "Upload Type", selector: row => row.type, sortable: true, wrap: true },
   { name: "Date Time", selector: row => row.date, sortable: true, wrap: true },
   
];

  columns = [
    ...columns,
    
    ...baseColumns
  ];

  if (metaData.typess?.toUpperCase() === "ADMIN" || metaData.typess?.toUpperCase() === "STAFF") {
    columns.push({
    name: (
    <div className="d-flex align-items-center">
      <span>Upload By</span>
    </div>
  ),
      cell: (row) => (
        <div>
          <span className="badge badge-lg p-2 bg-primary-transparent fs-14 search-value" data-tooltip-place="right" data-tooltip-id="global-tooltip" data-tooltip-content={row.createtype}>{row.uploadby}</span>
        </div>
      ),
      sortable: false,
    });
  }

if (metaData.typess?.toUpperCase() === "ADMIN" || metaData.del === 1 || metaData.view === 1 || metaData.add === 1 || metaData.edit === 1) {
  columns.push({
    name: "Action",
    cell: row => (
      <div className="hstack gap-2 fs-15 justify-content-center">
        {(metaData.typess?.toUpperCase() === "ADMIN" || metaData.del === 1) && <button className="btn btn-sm btn-danger-light" onClick={() => DeleteData(row.id)}><i className="ri-delete-bin-line"></i></button>}
        {(metaData.typess?.toUpperCase() === "ADMIN" || metaData.edit === 1) && <button className="btn btn-sm btn-primary-light" onClick={() => EditData(row.id, "1")}><i className="ri-edit-line"></i></button>}
        {(metaData.typess?.toUpperCase() === "ADMIN" || metaData.view === 1) && <button className="btn btn-sm btn-success-light" onClick={() => EditData(row.id, "2")}><i className="ri-eye-line"></i></button>}
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  });
}

const recruiterColumns2 = [
  {
          name: <input type="checkbox" checked={selectedRows.length === currentRows.length} onChange={handleSelectAll} />,
          selector: row => row.id,
          cell: row => (
            <input
              type="checkbox"
              checked={selectedRows.includes(row.id)}
              onChange={e => handleRowSelect(row.id, e.target.checked)}
            />
          ),
          width: "80px",
        },
        {
            name: 'IVR Status',
            selector: row => row.cstatus,
            cell: row => {
              if (row.cstatus === 'pending') {
                return <span className="badge bg-warning text-dark">Pending</span>;
              } else if (row.cstatus === 'success') {
                return <span className="badge bg-success text-white">Accepted</span>;
              } else if (row.cstatus === 'decline') {
                return <span className="badge bg-danger">Rejected</span>;
              } else {
                return <span className='badge bg-secondary'>NOT ANSWERED</span>;
              }
            },
            width: "120px"
          },
        ...baseColumns
];

const vendorColumns2 = [
  {
          name: <input type="checkbox" checked={selectedRows.length === currentRows.length} onChange={handleSelectAll} />,
          selector: row => row.id,
          cell: row => (
            <input
              type="checkbox"
              checked={selectedRows.includes(row.id)}
              onChange={e => handleRowSelect(row.id, e.target.checked)}
            />
          ),
          width: "80px",
        },
        {
            name: 'IVR Status',
            selector: row => row.cstatus,
            cell: row => {
              if (row.cstatus === 'pending') {
                return <span className="badge bg-warning text-dark">Pending</span>;
              } else if (row.cstatus === 'success') {
                return <span className="badge bg-success text-white">Accepted</span>;
              } else if (row.cstatus === 'decline') {
                return <span className="badge bg-danger">Rejected</span>;
              } else {
                return <span className='badge bg-secondary'>NOT ANSWERED</span>;
              }
            },
            width: "120px"
          },
        ...baseColumns
];

const currentColumns = activeTab === "recruiter" ? recruiterColumns2 : vendorColumns2;


const checkboxColumns = [
  {
    name: (
      <input
        type="checkbox"
        checked={selectedRows.length === currentRows.length}
        onChange={handleSelectAll}
      />
    ),
    selector: row => row.id,
    cell: row => (
      <input
        type="checkbox"
        checked={selectedRows.includes(row.id)}
        onChange={e => handleRowSelect(row.id, e.target.checked)}
      />
    ),
    width: "80px",
  },
  ...baseColumns
];

const recruiterColumns = [...checkboxColumns];
const vendorColumns = [...baseColumns];
  
   // ✅ Loader while checking session
  if (newloading) {
    
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

const RecruiterForm = async (e) => {
  e.preventDefault();

  if (selectedRecruiter === null) {
    Swal.fire({
      position: "top-center",
      icon: 'question',
      title: "Please select Recruiter",
      showConfirmButton: false,
      timer: 2000,
    })
    return false;
  }

  const ids = selectedRows.join(",");

  try {
    $("#showLoader").removeClass("d-none").addClass("d-flex"); // show loader
    const formData = new FormData();
    formData.append("value", ids);
     formData.append("person", selectedRecruiter);
     formData.append("aid",aid);
     formData.append("formType",aidtype);

    const response = await axios.post(apiurl + "allotement.php",formData);

    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader

    Swal.fire({
      position: "top-center",
      icon: response.data.icon,
      title: response.data.message,
      showConfirmButton: false,
      timer: 2000,
    }).then(() => {
      $("#RecruiterModal .btn-close").click();
      selectRecruiter(null);
      setSelectedRows([]); // clear all
    });
  } catch (error) {
    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader on error
    Swal.fire({
      position: "top-center",
      icon: "error",
      title: "Something went wrong!",
      text: error.message,
    });
  }
};

const SendForApproval =  async () =>{
  if (isSubmittingRequest) return;

  if (selectedRows === null) {
    Swal.fire({
      position: "top-center",
      icon: 'question',
      title: "Please select at least one checkbox",
      showConfirmButton: false,
      timer: 2000,
    })
    return false;
  }

  const ids = selectedRows.join(",");

  try {
    setIsSubmittingRequest(true);
    $("#showLoader").removeClass("d-none").addClass("d-flex"); // show loader
    const formData = new FormData();
    formData.append("value", ids);
     formData.append("person", selectedRecruiter);
     formData.append("aid",aid);
     formData.append("formType",aidtype);

    const response = await axios.post(apiurl + "allotement.php",formData);

    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader
    Swal.fire({
      position: "top-center",
      icon: response.data.icon,
      title: response.data.message,
      showConfirmButton: false,
      timer: 2000,
    }).then(() => {
      setSelectedRows([]); // clear all
    });
  } catch (error) {
    $("#showLoader").removeClass("d-flex").addClass("d-none"); // hide loader on error
    Swal.fire({
      position: "top-center",
      icon: "error",
      title: "Something went wrong!",
      text: error.message,
    });
  } finally {
    setIsSubmittingRequest(false);
  }
};

const IvrFORM = async (e) =>{
       e.preventDefault();
       $("#showLoader").removeClass('d-none').addClass('d-flex');
     
    try {
      const formData = new FormData($("#submitform")[0]);
      formData.append("aid",aid);
      formData.append("ctablehidden",ivrdata.ctablehidden);
      formData.append('campid',ivrdata.campid);
      
      const response = await axios.post(apiurl + "line.php", formData);
      if (response.data.status === true) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $(".offcanvas .btn-close").click();
        });
      }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
    }
    finally {
       $("#showLoader").removeClass('d-flex').addClass('d-none');
    }
};

const candidatecolumns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Mobile", selector: (row) => row.mobile, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Profile", selector: (row) => row.profile, sortable: true },
];

const updateDetails = async (idd,val) => { 
       $("#showLoader").removeClass('d-none').addClass('d-flex');
       try{
        const formdate = new FormData();
        formdate.append("com",idd);
        formdate.append("value",val);
        formdate.append("candidates",selectedRows);
        
         const response = await axios.post(apiurl + 'ivr.php',formdate);
         if(response.data.status === true){
            $("#tera_modal3").click();
            setIvr(idd);
            setIvrData(response.data.main[0]);
            setCandidates(response.data.candidates);
         }
         else{
                 Swal.fire({
                    position: "top-center",
                    icon: "error",
                    title: "Something Went Wrong !",
                    showConfirmButton: false,
                    timer: 2000
                  });
         }
       }
       catch (error) {
        console.log("bhai error", error.response?.data?.message); // Handle errors with informative messages
       }
       finally {
         $("#showLoader").removeClass('d-flex').addClass('d-none');
       }
};

 const toggleRequirement = (requireid) => {
    setOpenReqs((prev) => ({
      ...prev,
      [requireid]: !prev[requireid],
    }));
 };

return(
<>

<button data-bs-toggle="modal" id="showRecruiterModal" data-bs-target="#RecruiterModal" type="button" style={{ display: 'none' }}></button>
<button data-bs-toggle="offcanvas" id="tera_modal3" data-bs-target="#exampleModal2" type="button" style={{ display: 'none' }}></button>

 <div className="offcanvas offcanvas-top" style={{ maxHeight: '100%', height: 'auto', backgroundColor: 'rgb(245 245 245)' }} tabIndex="-1" id="exampleModal2" >
        <div className="offcanvas-header border-bottom border-block-end-dashed">
          <h5 className="offcanvas-title" id="offcanvasRightLabel1">Start LINE UP</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose" aria-label="Close"></button>
        </div>
        <div className="offcanvas-body" style={{ paddingBottom: '80px' }}>
         
            <form id="submitform" onSubmit={IvrFORM} encType="multipart/form-data" className='order-2'>
             <div className="row g-3">
              {(aidtype=='20') && (
                 <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="organName" className="form-label">Campaign Id</label>
                  <input value={ivrdata.campid || ""} type="text" className="form-control" placeholder="Campaign ID" readOnly disabled/>
                </div>
              )}
              
                 <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="organName" className="form-label">Requirement Id</label>
                  <input value={ivrdata.requireid || ""} name='requireid' type="text" className="form-control" placeholder="Require ID" readOnly disabled/>
                </div>
                
                <div className="col-xl-4 col-lg-4 col-md-6">
                  <label htmlFor="organName" className="form-label">Client Name</label>
                  <input value={ivrdata.client || ""} type="text" className="form-control" placeholder="Organisation name" readOnly  disabled/>
                </div>
                 <div className="col-xl-4 col-lg-3 col-md-6">
                  <label htmlFor="client" className="form-label">CLIENT EMAIL</label>
                  <input  value={ivrdata.cemail || ""} type="text" className="form-control" placeholder="CLIENT EMAIL"  readOnly  disabled/>
                </div>
                <div className="col-xl-4 col-lg-3 col-md-6">
                  <label htmlFor="skills" className="form-label">Location</label>
                  <input  value={ivrdata.location || ""}  type="text" className="form-control" placeholder="Location"  readOnly  disabled/>
                </div>
                <div className="col-xl-4 col-lg-3 col-md-6">
                  <label htmlFor="short" className="form-label">Job Title</label>
                  <input  value={ivrdata.jobTitle || ""} type="text" className="form-control" placeholder="JOB TITLE"  readOnly  disabled/>
                </div>
                 <div className="col-xl-6 col-lg-6 col-md-6 text-center">
                    <img src={process.env.PUBLIC_URL + "/images/media/wait.avif"} style={{ width: '60%'}} />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                    
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="pid" className="form-label"><span className='text-danger fs-15'>*</span>SPOC PERSON ID (AIP LOGIN_ID)</label>
                  <input id="pid" name="pid" type="text" className="form-control" placeholder="SPOC PERSON ID" required />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="pname" className="form-label">SPOC PERSON NAME</label>
                  <input id="pname" name="pname" type="text" className="form-control" placeholder="SPOC PERSON NAME" />
                </div>
               <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="itime" className="form-label">INTERVIEW TIME</label>
                  <input id="itme" name="itime" type="time" className="form-control" required/>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="sdate" className="form-label"><span className='text-danger fs-15'>*</span>SELECT INTERVIEW DATE</label>
                  <input id="sdate" name="sdate" type="date" className="form-control" placeholder="Caller Name"  required/>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 mb-4">
                  <label htmlFor="ldate" className="form-label"><span className='text-danger fs-15'>*</span>LINE REQUEST DATE</label>
                  <input id="ldate" name="ldate" type="date" className="form-control" placeholder="Mobile Number" required />
                </div> 
                <div className='col-12' style={{zIndex:'99999',padding: "7px 20px",textAlign: "right",position: "fixed",bottom: 0,right: 0, background: "#fff",boxShadow: "-4px -4px 4px darkgrey"}}>
                  <input type="hidden" name="hidden" value={ivr} />
                  <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </div> 

                </div>
                
           </div>
            
            </form>
          
        <div className='row'>
          <div className='col-6'>
            <h5>Line Up Candidate's</h5>
              <DataTable
          columns={candidatecolumns}
          data={candidates}
          pagination
          highlightOnHover
          striped
          responsive
        />
          </div>
        </div>
        </div>

 </div>


 <div className="modal fade effect-horizontal" id="RecruiterModal" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="exampleModalLabel1" style={{ display: 'none' }} aria-hidden="true">
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="exampleModalLabel1">Choose Recruiter</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
           
              <div className="modal-body">
                      <form onSubmit={RecruiterForm} noValidate>
                          
                       <div className='col-xl-12 col-lg-12 col-md-12'>
                       <label htmlFor='' className='form-label'>Select Staff</label>
                  
                  <Select
                    options={recruiter || []}   // must be an array
                    value={(recruiter || []).find(opt => opt.value == selectedRecruiter) || null}
                    onChange={(option) => selectRecruiter(option ? option.value : null)}
                    placeholder="Select Recruiter"
                  />
                  
                   </div>
                 <button type="submit" style={{marginTop:'10px',float:'right'}} className="btn btn-primary">Submit</button>
                      </form>
                     
              </div>
             
          </div>
        </div>
 </div>

<div className="offcanvas offcanvas-top" style={{maxHeight:'100%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="exampleModal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1">{metaData.appname}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="modalclose"  aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   
   <div className='d-flex'>

  <form id="mainForm" onSubmit={FormSubmit} encType="multipart/form-data" className='order-2'>
<div className="row g-3" style={{position:'relative'}}>
          		<div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="name" className="form-label">Name</label>
                      <input  id="name" name="name" className="form-control" autoComplete='off'  placeholder='Candidate Name' required />
                </div>
                <div className="col-lg-6">
                       <label htmlFor="mobile" className="form-label">Mobile No.</label>
                      <input  id="mobile" name="mobile" className="form-control" autoComplete='off' placeholder='Mobile No.' maxLength={10} minLength={10} inputMode='numeric' required defaultValue=""/>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="email" className="form-label">Email</label>
                      <input  id="email" name="email"  type="email" className="form-control" autoComplete='off' placeholder='Email adddress' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="profile" className="form-label">Profile</label>
                      <input  id="profile" name="profile" className="form-control" autoComplete='off' placeholder='Enter Your Profile' required defaultValue=""/>
                </div>

                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="age" className="form-label">Age</label>
                      <input  id="age" name="age" className="form-control" autoComplete='off'  placeholder='Enter Age' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="qual" className="form-label">Qualification</label>
                      <select  id="qual" name="qual" className="form-control" required defaultValue="">
                         <option value="" hidden>Select Qualification</option>
                          <option value="Below 10th">Below 10th</option>
<option value="10th Pass">10th Pass</option>
<option value="12th Pass">12th Pass</option>
<option value="Diploma">Diploma</option>
<option value="Graduate">Graduate</option>
<option value="Post Graduate">Post Graduate</option>
<option value="Doctorate">Doctorate (PhD)</option>
<option value="Professional Certification">Professional Certification</option>
<option value="Other">Other</option>
                      </select>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="exp" className="form-label">Experience</label>
                      <select  id="exp" name="exp" className="form-control" required defaultValue="">
                        <option value="" hidden>Enter Experience</option>
                    <option value="Fresher">Fresher</option>
<option value="<1 year">&lt;1 year</option>
<option value="1-2 years">1–2 years</option>
<option value="2-3 years">2–3 years</option>
<option value="3-4 years">3–4 years</option>
<option value="4-5 years">4–5 years</option>
<option value="5-7 years">5–7 years</option>
<option value="7-10 years">7–10 years</option>
<option value="10+ years">10+ years</option>
<option value="15+ years">15+ years</option>
                     </select>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="pincode" className="form-label">Pincode</label>
                      <input  id="pincode" name="pincode" className="form-control" autoComplete='off' minLength={6} maxLength={6} placeholder='Enter Your Pincode' required defaultValue=""/>
                </div>

                <div className="col-lg-6">
                       <label htmlFor="city" className="form-label">City/District</label>
                      <input  id="city" name="city" className="form-control" autoComplete='off' placeholder='Enter City' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="state" className="form-label">State</label>
                      <input  id="state" name="state" className="form-control" autoComplete='off'  placeholder='Enter your State' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>
                <div className="col-lg-2" id='resumelabel'>
                     {/* Category Input */}
                     <p className="form-label">Upload Resume</p>
                      <input id="resume" accept="image/*,.pdf" onChange={handleFileChange} name="resume" className="form-control" autoComplete='off' type='file' defaultValue="" style={{display:'none'}}/>
                      <label htmlFor="resume"  className='form-label' style={{width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <span style={{fontSize:'35px',marginTop:'-9px',display:'inline-block'}}>+</span>
                      </label>
                </div>
                <div className='col-lg-4' id='fileTxt'>
        {fileUrl && fileType?.startsWith('image/') && (
          <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%' ,height:'150px'}} />
        )}

        {fileUrl && fileType == 'application/pdf' && (
          <iframe src={fileUrl} title="PDF Preview" style={{width:'100%',height:'150px'}}></iframe>
        )}

        {fileUrl && !fileType.startsWith('image/') && fileType != 'application/pdf' && (
          <p>File preview not supported for this file type.</p>
        )}
      </div>
        
             <div className='col-12'  style={{padding:'0px',textAlign:'right'}}>
              <input type="hidden" name="hidden" id="hidden" />
              <input type='hidden' name='aid' id='aid' value={aid}/>
              <input type="hidden" name="token" value={sessionStorage.getItem('token')}/>
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Submit</button>
            </div>
    </div>
      </form>

      <img className="order-1" src={process.env.PUBLIC_URL + "/admin_assets/images/media/media-88.svg"} style={{width:'100%',height:'100%'}}/> 

   </div>
   
 
</div>

</div>

<div className="offcanvas offcanvas-end" style={{width:'45%',height:'auto',backgroundColor:'rgb(245 245 245)'}} tabIndex="-1" id="bulkmodal" >
    <div className="offcanvas-header border-bottom border-block-end-dashed">
         <h5 className="offcanvas-title" id="offcanvasRightLabel1">Candidate Registration in Bulk</h5>
        <button type="button" className="btn-close" id='modalclose2' data-bs-dismiss="offcanvas" aria-label="Close"></button>
     </div>
<div className="offcanvas-body">
   <form id="bulkform" onSubmit={BulkFormSubmit} encType="multipart/form-data">
<div className="row g-3" style={{position:'relative'}}>
          		<div className="col-lg-6" >
                     {/* Category Input */}
                     <label htmlFor="name2" className="form-label">Spoc Name</label>
                      <input  id="name2" name="name2" className="form-control" autoComplete='off'  placeholder='Spoc Name' required defaultValue=""/>
                </div>
                <div className="col-lg-6">
                       <label htmlFor="mobile2" className="form-label">Spoc Mobile No.</label>
                      <input  id="mobile2" name="mobile2" className="form-control" autoComplete='off' placeholder='Spoc Mobile No.' maxLength={10} minLength={10} inputMode='numeric' required defaultValue=""/>
                </div>
             
                <div className="col-lg-6">
                       <label htmlFor="location2" className="form-label">Spoc Location</label>
                      <input  id="location2" name="location2" className="form-control" autoComplete='off' placeholder='Spoc Location' required defaultValue="" style={{textTransform:'uppercase'}}/>
                </div>

                <div className="col-lg-6" style={{paddingTop:'30px'}}>
                  <button className="btn btn-sm btn-danger" onClick={()=>{window.location=`${process.env.REACT_APP_EXPORT_URL || "/"}demo/demobul.xlsx`;}} type="button">Demo Bulk Download</button>
                </div>

                <div className='col-12'>
                  <p className="form-label">Scan File</p>
                      <input id="bulk" style={{display:'none'}}  accept=".csv" name="bulk" className="form-control" autoComplete='off' type='file' defaultValue=""/>
                    <label htmlFor="bulk"  className='form-label' style={{width:'60px',height:'60px',textAlign:'center',alignContent:'center',border:'2px solid',borderColor:'rgb(var(--primary-rgb))!important'}}>
                           <i className='ri-qr-scan-2-line' style={{fontSize:'25px'}}></i>
                      </label>
                </div>
     
             <div className='col-12' style={{padding:'0px',textAlign:'right',position:'fixed',bottom:'20px',right:'20px'}}>
              <input type='hidden' name='aid' id='aid' value={aid}/>
              <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{marginRight:'20px',display:'none'}}/>
            <button type="submit" className="btn btn-primary">Upload</button>
            </div>
    </div>
      </form>
</div>

</div>

<div className="main-content app-content">
                 
 <div className="container-fluid">
 
<div className="row">
  <div className="col-xxl-9 col-xl-8 col-lg-8 col-md-6 col-sm-12  mt-3 mb-4">
    <div className="card custom-card" style={{marginBottom:'0px'}}> 
      <div className="card-body">
    
        <div className="row gy-3">

          <div className='col-xl-4'>
            <label htmlFor='profiles' className='form-label'>Select Profile</label>
             <Select
          options={profileOptions}
          onChange={handleProfileChange}
          value={selectedProfile}
          placeholder="Enter Profile"
          isSearchable
        />
          </div>
       
          <div className="col-xl-4">
            <label htmlFor="location" className="form-label">Select Location</label>
            <Select
          options={locationOptions}
          onChange={handleLocationChange}
          value={selectedLocation}
          placeholder="Enter location"
          isSearchable
        />
          </div>

          <div className="col-xl-4">
            <label htmlFor="expp" className="form-label">Select Experience</label>
           <Select
        options={groupbyExp}
        value={selectedExp}
        onChange={handleExpChange}
        isSearchable
        placeholder="Enter experience"
      />
          </div>

        </div>
      </div>
    </div>
  </div>
 <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 mt-3 mb-4">
    <div className="card custom-card mb-0">
        <div className="card-body">
            <div className="d-flex justify-content-between">
                <div className="me-1">
                    <h6 className="fs-16 mg-b-3">{metaData.appname}</h6>
                    <p className="fs-12 fw-semibold badge bg-primary-transparent" style={{marginBottom:'0px',padding:'10px'}}>Total : {total}</p>
                </div>
                <div className="min-w-fit-content">
                    <div className="avatar bg-primary-transparent"><i className={metaData.icon+" fs-28"}></i></div>
                </div>
            </div>
           
        </div>
    </div>
</div>

</div>

<div className="row">
   
<div className="col-xxl-12 col-xl-12 ">
   
<div className="card custom-card">
  
<div className="card-header justify-content-between" style={{ paddingBottom: '10px', alignItems: 'normal' }}>
  {aidtype === '10' ? (
    // ✅ Case 1: Tab view (Recruiter & Vendor)
    <nav className="nav nav-style-1 nav-pills gap-3" role="tablist">
      <button
        className={`nav-link ${activeTab === "recruiter" ? "active" : ""}`}
        onClick={() => setActiveTab("recruiter")}
      >
        Recruiter{" "}
        <span className="badge bg-danger ms-1 rounded-pill">
          {recruiterCandidates.length}
        </span>
      </button>

      <button
        className={`nav-link ${activeTab === "vendor" ? "active" : ""}`}
        onClick={() => setActiveTab("vendor")}
      >
        Vendor{" "}
        <span className="badge bg-danger ms-1 rounded-pill">
          {vendorCandidates.length}
        </span>
      </button>
    </nav>
  ) : (
   <>
    
 <div className="d-flex align-items-center gap-3 mb-0">
    {aidtype !== '2' && (
      <>
        {/* Both */}
        <label className="btn btn-primary text-white position-relative" style={{ minWidth: '120px' }}>
          <input
            type="checkbox"
            checked={!showVendor && !showRecruiter}
            onChange={() => {
              setShowVendor(false);
              setShowRecruiter(false);
            }}
            style={{
              position: 'absolute',
              top: '8px',
              left: '8px',
              transform: 'scale(1.1)',
              cursor: 'pointer'
            }}
          />
          <span>Both</span>
          <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
            {primaryCount}
          </span>
        </label>

        {/* Recruiter */}
        <label className="btn btn-info text-white position-relative" style={{ minWidth: '130px' }}>
          <input
            type="checkbox"
            checked={showRecruiter}
            onChange={() => setShowRecruiter(!showRecruiter)}
            style={{
              position: 'absolute',
              top: '8px',
              left: '8px',
              transform: 'scale(1.2)',
              cursor: 'pointer'
            }}
          />
          <span>Recruiter</span>
          <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
            {warningCount}
          </span>
        </label>

        {/* Vendor */}
        <label className="btn btn-secondary text-white position-relative" style={{ minWidth: '130px' }}>
          <input
            type="checkbox"
            checked={showVendor}
            onChange={() => setShowVendor(!showVendor)}
            style={{
              position: 'absolute',
              top: '8px',
              left: '8px',
              transform: 'scale(1.2)',
              cursor: 'pointer'
            }}
          />
          <span>Vendor</span>
          <span className="position-absolute top-50 translate-middle badge rounded-pill bg-danger text-white" style={{ pointerEvents: 'none', right: '-7%' }}>
            {secondaryCount}
          </span>
        </label>
      </>
    )}
  </div>
   </>
  )}

  {/* ✅ Right side buttons + search + add */}
  <div className="d-flex mt-sm-0 mt-2 align-items-center" style={{ width: '35%' }}>
    {selectedRows.length > 0 && (
      <>
        {(metaData.typess.toUpperCase() === 'STAFF' && aidtype === '3') && (
          <button
            className="btn btn-primary btn-sm"
            type="button"
            onClick={() => $("#showRecruiterModal").click()}
            style={{ width: '150px' }}
          >
            Select Recruiter
          </button>
        )}

        {(metaData.typess.toUpperCase() === 'STAFF' && aidtype === '202') && (
          <button
            className="btn btn-primary btn-sm"
            type="button"
            onClick={SendForApproval}
            style={{ width: '150px' }}
            disabled={isSubmittingRequest}
          >
            Send For Approval
          </button>
        )}
 {(metaData.typess.toUpperCase() === 'STAFF' && aidtype === '20') && (
         <button
            className="btn btn-primary btn-sm"
            type="button"
            onClick={() => updateDetails(aid, aidtype)}
            style={{ width: '100px' }}
          >
            LINE UP
          </button>
 )}
      </>
    )}

    {/* ✅ Search box */}
    <div className="input-group">
      <input
        type="text"
        className="form-control bg-light border-0"
        placeholder="Search Candidate"
        aria-describedby="search-contact-member"
      />
      <button className="btn btn-light" style={{ zIndex: '0' }} type="button" id="search-contact-member">
        <i className="ri-search-line text-muted"></i>
      </button>
    </div>

    {/* ✅ Dropdown */}
    <div className="dropdown ms-2">
      <button
        className="btn btn-icon btn-primary-light btn-wave waves-effect waves-light"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="ti ti-dots-vertical"></i>
      </button>
      <ul className="dropdown-menu">
        <li>
          <Link className="dropdown-item" to={`/admin/appdash/${aid}`} target="_blank">
            Dashboard
          </Link>
        </li>
        {(metaData.typess.toUpperCase() === 'ADMIN' || metaData.add === 1) && (
          <li>
            <a className="dropdown-item" href="#bulkmodal" data-bs-toggle="offcanvas" id="bulkupload">
              Bulk Upload
            </a>
          </li>
        )}
      </ul>
    </div>

    {/* ✅ Floating add button */}
    {(metaData.typess.toUpperCase() === 'ADMIN' || metaData.add === 1) && (
      <button
        className="btn btn-icon btn-primary ms-2"
        data-bs-toggle="offcanvas"
        id="addStaffbtn"
        data-bs-target="#exampleModal"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '4.313rem',
          height: '4.313rem',
          borderRadius: '50%',
          zIndex: '1',
        }}
      >
        <i className="ri-add-line" style={{ fontSize: '35px' }}></i>
      </button>
    )}
  </div>
</div>

<div className="card-body" style={{ padding: '10px' }}>
  <div className={styles.category_table} style={{ paddingTop: '0px' }}>
    {aidtype === '10' ? (
      <>
        {activeTab === "recruiter" ? (
          (groupedRecruiterData || []).map((req) => (
            <div key={req.aid} className="mb-3 border rounded shadow-sm bg-white">
              {/* Requirement Header Row */}
              <div
                className="d-flex align-items-center justify-content-between p-2 bg-light border-bottom"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setOpenReqs((prev) => ({ ...prev, [req.aid]: !prev[req.aid] }))
                }
              >
                <div className="d-flex align-items-center gap-2">
                  {openReqs[req.aid] ? (
                    <i className="ri-arrow-down-s-line fs-5"></i>
                  ) : (
                    <i className="ri-arrow-right-s-line fs-5"></i>
                  )}
                  <h6 className="m-0 fw-bold text-primary">
                    Requirement ID: {req.requireid}
                  </h6>
 
                </div>
                <div className='d-flex'>

                <span className="badge bg-secondary fs-15">
                  {req.candidates?.length || 0} Candidates
                </span>
                </div>
                
              </div>

              {/* Collapsible Recruiter Table */}
              {openReqs[req.aid] && (
                <div
                  className="p-3"
                  style={{
                    background: "#f9f9f9",
                    borderTop: "1px solid #ddd",
                  }}
                >
                  <DataTable
                    columns={recruiterColumns} // ✅ checkbox column included
                    data={req.candidates}
                    progressPending={loadings}
                    pagination
                    paginationPerPage={25}
                    highlightOnHover
                    striped
                    dense
                  />
                </div>
              )}
            </div>
          ))
        ) : (
          // 🔸 Vendor View — Flat Table (no collapsible)
          <DataTable
            columns={vendorColumns}
            data={vendorCandidates}
            progressPending={loadings}
            pagination
            paginationPerPage={50}
            paginationRowsPerPageOptions={[50, 100, 200, 300]}
            highlightOnHover
            fixedHeader
            striped
          />
        )}
      </>
    ) : (
        <>
      {(() => {
    if (showRecruiter && !showVendor) {
      return (
        <DataTable
          columns={currentColumns}
          data={recruiterCandidates}
          progressPending={loadings}
          pagination
          paginationPerPage={50}
          paginationRowsPerPageOptions={[50, 100, 200, 300]}
          highlightOnHover
          fixedHeader
          striped
        />
      );
    } else if (showVendor && !showRecruiter) {
      return (
        <DataTable
          columns={currentColumns}
          data={vendorCandidates}
          progressPending={loadings}
          pagination
          paginationPerPage={50}
          paginationRowsPerPageOptions={[50, 100, 200, 300]}
          highlightOnHover
          fixedHeader
          striped
        />
      );
    } else if(aidtype !== '2') {
      return (
        <DataTable
          columns={currentColumns}
          data={filteredStaff}
          progressPending={loadings}
          pagination
          paginationPerPage={50}
          paginationRowsPerPageOptions={[50, 100, 200, 300]}
          highlightOnHover
          fixedHeader
          striped
        />
      );
    }
  })()} 
  
  </>
    )}
  </div>
</div>


</div>
        
</div></div>

</div></div>

</>
);
}
export default LineRegister;
